"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const style_1 = __importDefault(require("./style"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const controlStyleToAtomStyle_1 = __importDefault(require("../../../shared/controlStyleToAtomStyle"));
const RadioButtonRender = ({ radioControl, }) => {
    var _a;
    const { Render, functions: { processor }, getColorFromSpecification, globalFontSize, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(radioControl);
    (0, useOnLoad_1.default)(radioControl, events);
    const onChangeValue = (0, react_1.useCallback)((value) => {
        if (radioControl.value === value) {
            return;
        }
        if (events.onChange) {
            events.onChange(value);
        }
        processor.root.updateControlById({
            control: radioControl,
            dataToUpdate: {
                value,
            },
        });
    }, [radioControl, events, processor]);
    const atomStyle = (0, controlStyleToAtomStyle_1.default)({
        getColorFromSpecification,
        globalFontSize,
        style: (_a = radioControl.style) !== null && _a !== void 0 ? _a : {},
    });
    return (react_1.default.createElement(Render.View, { style: Object.assign(Object.assign({}, atomStyle), { flexDirection: radioControl.formOrientation === 'horizontal' ? 'row' : 'column', alignItems: 'center' }) }, (radioControl.items || []).map(({ label, value: currentValue }) => (react_1.default.createElement(Render.TouchableOpacity, { key: currentValue, style: Object.assign(Object.assign(Object.assign({}, style_1.default.radioButtonItem), (radioControl.labelOrientation === 'horizontal' && style_1.default.labelHorizontal)), { paddingBottom: atomStyle.paddingBottom, paddingLeft: atomStyle.paddingLeft, paddingRight: atomStyle.paddingRight, paddingTop: atomStyle.paddingTop, marginBottom: atomStyle.marginBottom, marginLeft: atomStyle.marginLeft, marginRight: atomStyle.marginRight, marginTop: atomStyle.marginTop }), onPress: () => onChangeValue(currentValue) },
        react_1.default.createElement(Render.View, { style: Object.assign(Object.assign({}, style_1.default.checkWrapper), { borderColor: atomStyle.color }) },
            react_1.default.createElement(Render.View, { style: Object.assign(Object.assign({}, style_1.default.check), (currentValue === radioControl.value && {
                    backgroundColor: atomStyle.color,
                })) })),
        react_1.default.createElement(Render.View, { style: style_1.default.labelWrapper },
            react_1.default.createElement(Render.Text, { style: {
                    fontSize: atomStyle.fontSize,
                    color: atomStyle.color,
                    fontWeight: atomStyle.fontWeight || 'normal',
                    fontStyle: atomStyle.fontStyle || 'normal',
                    textDecorationLine: atomStyle.textDecoration || 'none',
                } }, label)))))));
};
exports.default = RadioButtonRender;
